<div class="container">
  <h1>Company Invoices <img class="add-icon" src="download_icon.svg" (click)="downloadCSV()" alt="Download CSV" title="Download CSV"></h1>
  <div class="legend">
    <div class="green legend-item" [class.legend-active]="activeStatusFilter === 'completed'" (click)="filterByStatus('completed')">
      <div class="legend-text">Completed</div>
      <div>{{ completedInvoiceAmount | currency: 'USD':'symbol':'1.0-0'}}</div>
    </div>
    <div class="yellow legend-item" [class.legend-active]="activeStatusFilter === 'no-invoice'" (click)="filterByStatus('no-invoice')">
      <div class="legend-text">No Invoice</div>
      <div>{{ noInvoiceAmount | currency: 'USD':'symbol':'1.0-0'}}</div>
    </div>
    <div class="legend-item" [class.legend-active]="activeStatusFilter === 'invoiced-not-collected'" (click)="filterByStatus('invoiced-not-collected')">
      <div class="legend-text">Invoiced Not Collected</div>
      <div>{{ invoicedNotCollected | currency: 'USD':'symbol':'1.0-0' }}</div>
    </div>
    <div class="red legend-item" [class.legend-active]="activeStatusFilter === 'overdue'" (click)="filterByStatus('overdue')">
      <div class="legend-text">Brand Payment Overdue</div>
      <div>{{ overdueInvoiceAmount | currency: 'USD':'symbol':'1.0-0' }}</div>
    </div>
    <div class="blue legend-item" [class.legend-active]="activeStatusFilter === 'creator-payment'" (click)="filterByStatus('creator-payment')">
      <div class="legend-text">Creator Payment Needed</div>
      <div>{{ creatorPaymentNeeded | currency: 'USD':'symbol':'1.0-0' }}</div>
    </div>
  </div>

  <div *ngIf="invoices.length > 0" class="clear-filters-row">
    <span class="clear-filters-link" (click)="clearFilters()">Clear Filters</span>
  </div>

  <div *ngIf="invoices.length > 0" class="invoice-table">
    <!-- Filter Row -->
    <div class="filter-cell">
      <input type="text" [(ngModel)]="refFilterString" (ngModelChange)="applyFilter()" placeholder="Filter by ref" style="width: auto; box-sizing: border-box; display: inline-block;">
    </div>
    <div class="filter-cell"></div>
    <div class="filter-cell" style="white-space: nowrap;">
      <input type="text" [(ngModel)]="campaignNameFilter" (ngModelChange)="applyFilter()" placeholder="Filter by name" style="width: auto; box-sizing: border-box; display: inline-block;">
    </div>
    <div class="filter-cell" style="white-space: nowrap;">
      <input type="text" [(ngModel)]="selectedCreatorName" (ngModelChange)="applyFilter()" placeholder="Filter by creator" style="width: auto; box-sizing: border-box; display: inline-block;">
    </div>
    <div class="filter-cell"></div>
    <div class="filter-cell" style="white-space: nowrap;">
      <input type="text" [(ngModel)]="accountFilter" (ngModelChange)="applyFilter()" placeholder="Filter by account" style="width: auto; box-sizing: border-box; display: inline-block;">
    </div>
    <div class="filter-cell"></div>
    <div class="filter-cell"></div>
    <div class="filter-cell"></div>
    <div class="filter-cell" style="white-space: nowrap;">
      <input type="text" [(ngModel)]="rateFilter" (ngModelChange)="onRateFilterChange()" placeholder="Filter by rate" style="width: auto; box-sizing: border-box; display: inline-block; text-align: right;">
    </div>
    <div class="filter-cell"></div>
    <div class="filter-cell"></div>
    <div class="filter-cell"></div>

    <!-- Header Row -->
    <div class="header">Invoice ID</div>
    <div class="header">Status</div>
    <div class="header truncate">Campaign Name</div>
    <div class="header">Creator Name</div>
    <div class="header">Rate</div>
    <div class="header truncate">Account</div>
    <div class="header">Issue Date</div>
    <div class="header">Due Date</div>
    <div class="header">Paid Date</div>
    <div class="header right">Invoice<br>Rate</div>
    <div class="header right">Acual Pay<br>Amount</div>
    <div class="header right">Creator<br>Pay</div>
    <div class="header right">Creator Pay<br>Date</div>


    <ng-container *ngIf="filteredInvoices.length > 0">
      <ng-container *ngFor="let i of filteredInvoices">
  <div class="cell"
  [class.red]='isOverdue(i.dueDate!) && !i.paidDate'
  [class.blue]='i.actualPayAmount && i.actualPayAmount > 0 && !i.creatorPaidDate'
  [class.green]='i.actualPayAmount && i.actualPayAmount > 0 && i.creatorPaidDate'
  [class.yellow]="i.invoiceNumber === 'no-invoice'">
          <a [routerLink]="['/agent/campaigns', i.campaignId]">{{i.invoiceNumber}}</a>
        </div>
  <div class="cell"
  [class.red]='isOverdue(i.dueDate!) && !i.paidDate'
  [class.blue]='i.actualPayAmount && i.actualPayAmount > 0 && !i.creatorPaidDate'
  [class.green]='i.actualPayAmount && i.actualPayAmount > 0 && i.creatorPaidDate'
  [class.yellow]="i.invoiceNumber === 'no-invoice'">{{ campaignStatusLookup[i.campaignId] }}</div>
  <div class="cell truncate"
  [class.red]='isOverdue(i.dueDate!) && !i.paidDate'
  [class.blue]='i.actualPayAmount && i.actualPayAmount > 0 && !i.creatorPaidDate'
  [class.green]='i.actualPayAmount && i.actualPayAmount > 0 && i.creatorPaidDate'
  [class.yellow]="i.invoiceNumber === 'no-invoice'">{{ campaignLookup[i.campaignId]?.name || '—' }}</div>
  <div class="cell"
  [class.red]='isOverdue(i.dueDate!) && !i.paidDate'
  [class.blue]='i.actualPayAmount && i.actualPayAmount > 0 && !i.creatorPaidDate'
  [class.green]='i.actualPayAmount && i.actualPayAmount > 0 && i.creatorPaidDate'
  [class.yellow]="i.invoiceNumber === 'no-invoice'">{{ getCreatorName(i) }}</div>
  <div class="cell"
  [class.red]='isOverdue(i.dueDate!) && !i.paidDate'
  [class.blue]='i.actualPayAmount && i.actualPayAmount > 0 && !i.creatorPaidDate'
  [class.green]='i.actualPayAmount && i.actualPayAmount > 0 && i.creatorPaidDate'
  [class.yellow]="i.invoiceNumber === 'no-invoice'">{{ campaignLookup[i.campaignId]?.rate | currency:'USD':'symbol':'1.2-2' }}</div>
  <div class="cell truncate"
  [class.red]='isOverdue(i.dueDate!) && !i.paidDate'
  [class.blue]='i.actualPayAmount && i.actualPayAmount > 0 && !i.creatorPaidDate'
  [class.green]='i.actualPayAmount && i.actualPayAmount > 0 && i.creatorPaidDate'
  [class.yellow]="i.invoiceNumber === 'no-invoice'">{{ getAccountName(i) }}</div>
  <div class="cell right"
  [class.red]='isOverdue(i.dueDate!) && !i.paidDate'
  [class.blue]='i.actualPayAmount && i.actualPayAmount > 0 && !i.creatorPaidDate'
  [class.green]='i.actualPayAmount && i.actualPayAmount > 0 && i.creatorPaidDate'
  [class.yellow]="i.invoiceNumber === 'no-invoice'">
    <ng-container *ngIf="i.invoiceNumber !== 'no-invoice'">{{i.issueDate | date:'MM/dd/yy'}}</ng-container>
  </div>
  <div class="cell right"
  [class.red]='isOverdue(i.dueDate!) && !i.paidDate'
  [class.blue]='i.actualPayAmount && i.actualPayAmount > 0 && !i.creatorPaidDate'
  [class.green]='i.actualPayAmount && i.actualPayAmount > 0 && i.creatorPaidDate'
  [class.yellow]="i.invoiceNumber === 'no-invoice'">{{i.dueDate| date:'MM/dd/yy'}}</div>
  <div class="cell right"
  [class.red]='isOverdue(i.dueDate!) && !i.paidDate'
  [class.blue]='i.actualPayAmount && i.actualPayAmount > 0 && !i.creatorPaidDate'
  [class.green]='i.actualPayAmount && i.actualPayAmount > 0 && i.creatorPaidDate'
  [class.yellow]="i.invoiceNumber === 'no-invoice'">{{i.paidDate| date:'MM/dd/yy'}}</div>
  <div class="cell right"
  [class.red]='isOverdue(i.dueDate!) && !i.paidDate'
  [class.blue]='i.actualPayAmount && i.actualPayAmount > 0 && !i.creatorPaidDate'
  [class.green]='i.actualPayAmount && i.actualPayAmount > 0 && i.creatorPaidDate'
  [class.yellow]="i.invoiceNumber === 'no-invoice'">
    <ng-container *ngIf="i.invoiceNumber !== 'no-invoice'">{{ getInvoiceRate(i) | currency:'USD':'symbol':'1.2-2' }}</ng-container>
  </div>
  <div class="cell right"
  [class.red]='isOverdue(i.dueDate!) && !i.paidDate'
  [class.blue]='i.actualPayAmount && i.actualPayAmount > 0 && !i.creatorPaidDate'
  [class.green]='i.actualPayAmount && i.actualPayAmount > 0 && i.creatorPaidDate'
  [class.yellow]="i.invoiceNumber === 'no-invoice'">
    <ng-container *ngIf="i.invoiceNumber !== 'no-invoice'">{{i.actualPayAmount | currency:'USD':'symbol':'1.2-2'}}</ng-container>
  </div>
  <div class="cell right"
  [class.red]='isOverdue(i.dueDate!) && !i.paidDate'
  [class.blue]='i.actualPayAmount && i.actualPayAmount > 0 && !i.creatorPaidDate'
  [class.green]='i.actualPayAmount && i.actualPayAmount > 0 && i.creatorPaidDate'
  [class.yellow]="i.invoiceNumber === 'no-invoice'">
    <ng-container *ngIf="i.invoiceNumber !== 'no-invoice'">{{ i.creatorPayAmount | currency:'USD':'symbol':'1.2-2' }}</ng-container>
  </div>
  <div class="cell right"
  [class.red]='isOverdue(i.dueDate!) && !i.paidDate'
  [class.blue]='i.actualPayAmount && i.actualPayAmount > 0 && !i.creatorPaidDate'
  [class.green]='i.actualPayAmount && i.actualPayAmount > 0 && i.creatorPaidDate'
  [class.yellow]="i.invoiceNumber === 'no-invoice'">{{i.creatorPaidDate| date:'MM/dd/yy'}}</div>
      </ng-container>
    </ng-container>

  </div>
</div>

